import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router from '@/router'
import { useAppStore } from '@/stores/app'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        baseUrl: '/api/admin/v1',
        options: {
            beforeFetch({ options }) {
                const headers = new Headers(options.headers)
                headers.set('Authorization', `Bearer ${appStore.getJWT()}`)
                options.headers = headers

                return { options }
            },
            async onFetchError(ctx) {
                if (ctx.response?.status === 401) {
                    appStore.setLogout()
                    await router.push({ name: 'login' })
                }

                return ctx
            },
        },
    })

    return { fetch }
})
